import { useRef } from "react";

export function useObjectMemo<T extends object>(items: T): T {
  const ref = useRef<T>(items);

  if (
    Object.keys(ref.current).length !== Object.keys(items).length ||
    !Object.entries(items).every(
      ([key, value]) => value === ref.current[key as keyof T],
    )
  ) {
    ref.current = items;
  }

  return ref.current;
}
